// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"618ca959","455":"f53e68b7","977":"ee7dd744"}[chunkId] + ".chunk.js";
};